// Central editable site configuration for REBHAS Consultancy Services (RCS).
// Fill in real values when available — empty values render as placeholders.
export const SITE = {
  name: "REBHAS Consultancy Services",
  short: "RCS",
  tagline: "Consulting. Technology. Growth.",
  email: "",      // ADD OFFICIAL EMAIL
  phone: "",      // ADD OFFICIAL PHONE
  location: "",   // ADD BUSINESS LOCATION
  whatsapp: "",   // ADD WHATSAPP NUMBER (digits only, with country code, e.g. 919876543210)
  social: {
    linkedin: "",
    facebook: "",
    instagram: "",
    youtube: "",
  },
};

export const LOGO = "/assets/rcs-logo.jpeg";

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Solutions", href: "#solutions" },
  { label: "School SaaS", href: "#school-saas" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export const SERVICE_OPTIONS = [
  "Website Development",
  "Custom Software",
  "SaaS Development",
  "Mobile App",
  "School Management SaaS",
  "E-commerce",
  "AI & Automation",
  "Digital Consultancy",
  "Other",
];

export const BUDGET_OPTIONS = [
  "Under ₹50,000",
  "₹50,000 – ₹1,00,000",
  "₹1,00,000 – ₹3,00,000",
  "₹3,00,000 – ₹5,00,000",
  "₹5,00,000+",
  "Not Sure",
];

export const scrollToSection = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
